/** @deprecated to delete when smv toggle is deleted */
export const plotCreationSteps = [
  'location',
  'dataSource',
  'devicesSelection',
  'submit',
  'success'
] as const

export const plotCreationStepsWithVWS = [
  'location',
  'devicesSelection',
  'submit',
  'success'
] as const

export const plotCreationDataSources = ['vision', 'devices'] as const

export const getPlotCreationHref = (orgId: number) => `/farms/${orgId}/plots/create` as const
export const getPlotEditionHref = (orgId: number) => `/farms/${orgId}/plots/edit` as const

export const DEVICE_MARKER_WIDTH = 48
export const FOCUSED_DEVICE_MARKER_WIDTH = 160

/**
 * The number of path a polygon must have to be considered valid for GoogleMaps
 * In GoogleMaps, the coordinates loop don't need to be closed so [A, B, C] is the minimum
 */
export const MINIMUM_NUMBER_OF_POLYGON_PATHS = 3

/**
 * The number of path a polygon must have to be considered valid for GeoJSON
 * In GeoJSON, the coordinates loop must be closed so we don't need 3, like [A, B, C], but 4 [A, B, C, A]
 */
export const MINIMUM_NUMBER_OF_POLYGON_PATHS_FOR_GEOJSON = 4

export const PLOT_CREATION_MAP_PADDING = {
  top: 96,
  right: 64,
  bottom: 96,
  // Avoiding list and focus card
  left: 512
}

export enum MAP_Z_INDEXES {
  DEFAULT = 1,
  SELECTED = 2,
  FOCUSED = 3,
  TOOLTIP = 4,
  HOVERED = 5
}

export const GOOGLE_PLACES_INPUT_ID = 'google-places-autocomplete-input'
